module.exports = __webpack_public_path__ + "media/images/ui-icons_555555_256x240-dc602ca3.png";